import React, { useState } from 'react';
import { Alert } from 'antd';
import Spin from 'src/components/common/Spin';
import useQueryUrlParams from 'src/hooks/useQueryUrlParams';
import { ColumnSorting } from './AuditTable/AuditTable.config';
import useAuditListFetch from '../../../hooks/useAuditListFetch';
import { AuditTable } from './AuditTable';
import styles from './AuditList.module.less';

type AuditListProps = {
  columnName: string;
  scriptErrorConfigId: string | null;
};

export const AuditList: React.FC<AuditListProps> = ({ columnName, scriptErrorConfigId }) => {
  const { sortingcolumn = 'dateStamp', sortingorder = 'descend' } = useQueryUrlParams();

  const [sorting, setSorting] = useState<ColumnSorting>({ field: sortingcolumn, order: sortingorder });

  const [{ data, loading, error }] = useAuditListFetch({
    scriptErrorConfigId,
    columnName,
    sorting,
  });

  const firstLoading = loading && data === null;

  return (
    <>
      {error && (
        <Alert message="Error" description="Something went wrong. Please try again later..." type="error" showIcon />
      )}
      {firstLoading ? (
        <div className={styles.listLoader}>
          <Spin spinning={firstLoading} />
        </div>
      ) : (
        <AuditTable items={data || []} sorting={sorting} loading={loading} onSortingChange={setSorting} />
      )}
    </>
  );
};
